module.exports = __webpack_public_path__ + "static/media/Diligently.1a63a335.svg";